module.exports = __webpack_public_path__ + "img/spotify.aee4e77e.svg";